import React from "react";
import { Caption } from "@randajan/jet-react/dom/caption";
import { Button } from "@mui/material";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import "./CharacterIdentity.scss";
import { CharacterCard } from "../../CharacterCard/CharacterCard";


import { Block } from "@randajan/jet-react/dom/block";
import { usePop } from "@randajan/jet-react/dom/modal";
import { PinForm } from "../../_forms/PinForm/PinForm";
import { IdentityForm } from "../../_forms/IdentityForm/IdentityForm";
import { usePagePop } from "../../../PagePops/PagePops";

export const CharacterIdentity = props=>{
    const { profile={}, showMe } = props;

    const pinPop = usePagePop("pinForm");
    const identityPop = usePagePop("identityForm");


    return (
        <Block tagName="section" className="CharacterIdentity wall -form">
            <CharacterCard profile={profile} fullSize />

            {showMe && <section className="controls">{pinPop?.button}{identityPop?.button}</section>}
        </Block>
    );
};
